'use client'

/**
 * BackButton — returns to the previous screen. Uses browser history when there is somewhere to go back
 * to, otherwise falls back to a sensible href (so a cold-loaded/shared link still has a way out).
 */

import { useRouter } from 'next/navigation'
import { ArrowLeft } from 'lucide-react'

export default function BackButton({ fallbackHref = '/', label = 'Back', className = '' }: { fallbackHref?: string; label?: string; className?: string }) {
  const router = useRouter()
  const goBack = () => {
    if (typeof window !== 'undefined' && window.history.length > 1) router.back()
    else router.push(fallbackHref)
  }
  return (
    <button
      onClick={goBack}
      className={`inline-flex items-center gap-1.5 rounded-lg border border-zinc-800 bg-zinc-900/60 px-2.5 py-1.5 text-xs font-semibold text-zinc-300 transition-colors hover:border-zinc-700 hover:text-white ${className}`}
    >
      <ArrowLeft className="h-3.5 w-3.5" /> {label}
    </button>
  )
}
